import React from 'react';
import { Reveal } from './ui/Reveal';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section id="final-cta" className="py-24 bg-white text-center" data-id="element-61">
      <div className="max-w-3xl mx-auto px-6" data-id="element-62">
        <Reveal data-id="element-63">
          <h2 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-64">
            Es momento de dejar de sufrir y empezar a vivir
          </h2>
          <p className="text-xl text-gray-600 mb-10" data-id="element-65">
            Accede hoy a los 24 pasos y transforma tu vida de manera natural. Tu
            cuerpo y tu mente te lo agradecerán.
          </p>
          <Button variant="primary" href="#" className="w-full sm:w-auto text-xl px-10 py-5" data-id="element-66">
            Sí, quiero mi acceso ahora
          </Button>
          <p className="mt-6 text-sm text-gray-500" data-id="element-67">
            Pago 100% seguro. Acceso inmediato al material.
          </p>
        </Reveal>
      </div>
    </section>;
}